import formatDate from '@/common/functions/formatDate'

export const versionColumns = [
		{
			title: '商户名称',
			dataIndex: 'corpName',
			key: 'corpName'
		},
		{
			title: '模板ID',
			dataIndex: 'templateId',
			key: 'templateId'
		},
		{
			title: '小商店名称',
			dataIndex: 'shopName',
			key: 'shopName'
		},
		{
			title: '审核状态',
			dataIndex: 'auditStatus',
			customRender: ({text}) => {
                return { children: auditStatusMap[text]}
            }
		},
		{
			title: '失败原因',
			dataIndex: 'auditReason',
			key: 'auditReason',
			slots: { customRender: 'auditReason' }
		},
		{
			title: '不通过时间',
			dataIndex: 'auditFailTime',
			key: 'auditFailTime',
			customRender: ({text}) => {
                return formatDate(text)
            }
		},
		{
			title: '延后时间',
			dataIndex: 'auditDelayTime',
			key: 'auditDelayTime',
			customRender: ({text}) => {
                return formatDate(text)
            }
		},
		{
			title: '发布状态',
			dataIndex: 'releaseStatus',
			customRender: ({text}) => {
                return { children: releaseStatusMap[text]}
            }
		},
		{
			title: '发布时间',
			dataIndex: 'releaseTime',
			key: 'releaseTime',
			customRender: ({text}) => {
                return formatDate(text)
            }
		}
	]

    export const auditStatusMap = {
        0: '审核中',
        1: '审核通过',
        2: '审核不通过',
        3: '审核延后',
    }

    export const releaseStatusMap = {
        0: '未发布',
        1: '成功',
        2: '没有审核版本',
        3: '审核状态未满足发布',
    }

    export const templateColumns = [
		{
			title: '创建时间',
			dataIndex: 'createTime',
			key: 'createTime'
		},
		{
			title: '版本号',
			dataIndex: 'version',
			key: 'version'
		},
		{
			title: '描述',
			dataIndex: 'desc',
			key: 'desc'
		},
		{
			title: '操作',
			dataIndex: 'action',
			slot: 'action'
		}
	]